enum ProjectTableAction {
  GET_PROJECT_TABLE = 'getProjectTable',
  GET_PROJECT_TOTALS = 'getProjectTotals'
}

export default ProjectTableAction;
